import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M7.917 12.085v2.477c0 1.247.792 2.355 1.971 2.76l.325.11a1.25 1.25 0 0 0 1.59-.785l1.53-4.563h2.97c.66 0 1.197-.537 1.197-1.198V3.698c0-.661-.536-1.198-1.198-1.198H5.262c-1.1 0-2.058.749-2.325 1.815L1.74 9.107a2.396 2.396 0 0 0 2.325 2.977h3.853M13.333 2.5v9.584"
    />
  </svg>
);
export default SvgThumbsDown;
